import { Box, Center, GridItem, Image, Skeleton } from "@chakra-ui/react";
import { useState } from "react";

import { Dataset } from "@nens/rana/api-v1";
import { HEADING_STYLES, RanaButton, RanaHeading, SIZES } from "@nens/ranalib";

import DatasetNoImage from "@/images/dataset-no-image.png";
import { useDatasetThumbnailQuery } from "@/queries/query-dataset-thumbnail";

type DatasetCardProps = {
  dataset: Dataset;
  setDataset: (dataset: Dataset) => void;
};

const LINE_AMOUNT = 3 as const;
const HEADING_TYPE = "h5" as const;
const IMAGE_HEIGHT = SIZES[24];
const NON_CALC_TITLE_HEIGHT = `${HEADING_STYLES.sizes[HEADING_TYPE].lineHeight} * ${LINE_AMOUNT}`;
const TITLE_HEIGHT = `calc(${NON_CALC_TITLE_HEIGHT})`;
const BUTTON_PADDING = "16px";
export const DATASET_CARD_HEIGHT = `calc(${NON_CALC_TITLE_HEIGHT} + ${BUTTON_PADDING} + ${IMAGE_HEIGHT})`;

export const DatasetCard = ({ dataset, setDataset }: DatasetCardProps) => {
  const { resourceTitleObject } = dataset;
  const { data: thumbnailUrl, isLoading } = useDatasetThumbnailQuery(dataset);
  const [imageError, setImageError] = useState(false);

  return (
    <GridItem as={RanaButton} variant="listitem" onClick={() => setDataset(dataset)}>
      <Center
        as={isLoading ? Skeleton : undefined}
        rounded="base"
        overflow="hidden"
        alignItems="center"
        w="full"
        h={IMAGE_HEIGHT}
        mb={2}
      >
        <Image
          w="full"
          h="full"
          objectFit="cover"
          src={(!imageError && thumbnailUrl) || DatasetNoImage}
          alt="thumbnail-picture"
          onError={() => setImageError(true)}
        />
      </Center>
      <Box
        sx={{
          "*": {
            display: "-webkit-box",
            WebkitLineClamp: LINE_AMOUNT,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            minH: TITLE_HEIGHT,
          },
        }}
      >
        <RanaHeading
          title={resourceTitleObject._default ?? undefined}
          type={HEADING_TYPE}
          wordBreak="break-word"
        >
          {resourceTitleObject._default}
        </RanaHeading>
      </Box>
    </GridItem>
  );
};
